/**
 * Compares two semantic version strings (e.g. "1.0.10" and "1.0.2")
 * Returns 1 if v1 > v2
 * Returns -1 if v1 < v2
 * Returns 0 if v1 == v2
 */
export function compareVersions(v1: string, v2: string): number {
    const p1 = v1.split('.').map(Number);
    const p2 = v2.split('.').map(Number);

    const len = Math.max(p1.length, p2.length);

    for (let i = 0; i < len; i++) {
        const num1 = p1[i] || 0;
        const num2 = p2[i] || 0;

        if (num1 > num2) return 1;
        if (num1 < num2) return -1;
    }

    return 0;
}
